import { css } from '@emotion/react';

export const image = (imgUrl: string) => css`
  width: 96px;
  height: 96px;
  border-radius: 9px;
  ${imgUrl &&
  `background-image: url(${imgUrl}); background-size: cover; background-repeat: no-repeat; object-fit: cover;`}
`;

export const gridLayout = css`
  display: grid;
  gap: 16px;
  width: fit-content;
  grid-template-columns: 1fr 1fr;
  word-break: break-all;
  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const rootList = (isDisabled = false) => css`
  display: flex;
  align-items: center;
  padding: 24px;
  overflow: hidden;
  background: ${isDisabled ? 'var(--color-background-active)' : 'var(--color-white)'};
  border-radius: 0.8rem;
  &:hover {
    cursor: ${isDisabled ? '' : 'pointer'};
  }
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
`;

export const tag = css`
  background-color: #ffeeeb;
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  color: #ea503b;
  font-size: 12px;
`;
